import DynamicComponent from ".."

export default function IconGrid({ blok }) {
  return (
    <section className={`bg-${blok.background_color} px-5 py-10 lg:py-12`}>
      <div className="mx-auto max-w-screen-xl">
        <h2 className="text-primary text-center">{blok.heading}</h2>
        <div className="grid sm:grid-cols-2 gap-6 mt-10 lg:mt-14">
          {blok.icon_cards.map((card) => (
            <DynamicComponent blok={card} key={card.uid} />
          ))}
        </div>
      </div>
    </section>
  )
}
